var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.valid)?_c('v-btn',{attrs:{"small":"","text":"","color":"secondary","block":""},on:{"click":_vm.open}},[_vm._v("Pay Order")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }